import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

class ModalMessageIcon extends PureComponent {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
  };

  static defaultProps = {
    width: 80,
    height: 80,
  };

  render() {
    const { width, height, className } = this.props;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        className={className}
        viewBox="0 0 80 80"
      >
        <g fill="none" fillRule="evenodd" transform="translate(8.5 15)">
          <circle cx="20" cy="20" r="20" fill="#E8E8E8" />
          <path
            fill="#212121"
            fillRule="nonzero"
            d="M60.5 8c2.485 0 4.5 2.005 4.5 4.48v22.395h-1.8V12.479a2.694 2.694 0 0 0-2.7-2.687h-45a2.694 2.694 0 0 0-2.7 2.687v34.042a2.694 2.694 0 0 0 2.7 2.687h45c1.491 0 2.7-1.203 2.7-2.687V34.875H65v11.646C65 48.995 62.985 51 60.5 51h-45c-2.485 0-4.5-2.005-4.5-4.48V12.48C11 10.004 13.015 8 15.5 8zm-1.754 7L60 16.241 40.813 35.23a2.68 2.68 0 0 1-3.763 0L17 16.24 18.254 15l20.05 18.987a.894.894 0 0 0 1.255 0L58.746 15z"
          />
        </g>
      </svg>
    );
  }
}

export default ModalMessageIcon;
